import { Button, CircularProgress } from '@mui/material';
import { EnableKeywordAssistDialog } from './EnableKeywordAssistDialog';
import { useKeywordAssistMutation } from '../hooks/useKeywordAssistMutation';
import { Card } from 'src/components/UI/Card';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';

function KANoDataFound({ siteSoftDeleted }: { siteSoftDeleted: boolean }) {

  const { _id: siteId, user_id: userId } = useSelector((state: RootState) => state?.siteAudit?.siteAuditDetails) ?? {};

  const {
    dialogOpen,
    setDialogOpen,
    keywords,
    setKeywords,
    handleEnableKeywordAssist,
    runKeywordIntelligenceMutation
  } = useKeywordAssistMutation();

  return (
    <>
      <Card>
        <div className="px-6">
          <p className="text-primary font-semibold text-3xl">Keyword Assist</p>

          <div className="flex flex-col items-center justify-center gap-6 p-6 pb-0 w-full mt-2.5 mb-2.5">
            {runKeywordIntelligenceMutation.isPending ? (
              <>
                <div className="flex flex-col items-center justify-center gap-3 text-center min-h-[16rem]">
                  <CircularProgress size={64} />
                  <p className="font-semibold text-lg text-[#1D2939] mt-2">
                    Orbit AI Keyword Assist is running...
                  </p>
                  <p className="font-normal text-sm text-[#667085] max-w-md">
                    This may take a few moments while we analyze your site and discover high-value keywords.
                  </p>
                </div>
              </>
            ) : (
              <>
                <h3 className="font-medium text-lg text-center text-[#1D2939]">
                  No Keyword Assist Data Found
                </h3>
                <p className="font-normal text-sm leading-5 text-center text-[#667085]">
                  It looks like Keyword Assist hasn't been run or completed for
                  this site yet. Navigate to your SEO dashboard to start a
                  search scan.
                </p>
                <Button
                  onClick={() => setDialogOpen(true)}
                  disabled={siteSoftDeleted}
                  variant="contained"
                  sx={{
                    backgroundColor: 'var(--color-primary, #120242)',
                    color: '#FFFFFF',
                    textTransform: 'none',
                    fontWeight: 400,
                    borderRadius: '4px',
                    fontSize: '14px',
                    py: 1,
                    px: 3.5,
                    '&:hover': {
                      backgroundColor: 'rgba(18, 2, 66, 0.9)'
                    }
                  }}
                >
                  Run Keyword AI Assistant
                </Button>
              </>
            )}
          </div>
        </div>
      </Card>

      <EnableKeywordAssistDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onEnable={() => handleEnableKeywordAssist(keywords, { siteId, userId })}
        isLoading={runKeywordIntelligenceMutation.isPending}
      />
    </>
  );
}

export default KANoDataFound;
